// Hook do pobierania słownika handlowców – GET /sales-crm/traders/dictionary

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmTradersDictionaryItem {
  text: string;
  value: number;
}

export interface IGetSalesCrmTradersDictionaryResponse {
  page?: number;
  total_count?: number;
  total_pages?: number;
  items: ISalesCrmTradersDictionaryItem[];
}

const getSalesCrmTradersDictionary =
  (): Promise<IGetSalesCrmTradersDictionaryResponse> =>
    axios.get('/sales-crm/traders/dictionary');

export const useGetSalesCrmTradersDictionary = (
  options?: UseQueryOptions<IGetSalesCrmTradersDictionaryResponse, IError>
) =>
  useQuery<IGetSalesCrmTradersDictionaryResponse, IError>(
    ['sales-crm', 'traders', 'dictionary'],
    () => getSalesCrmTradersDictionary(),
    options
  );
